module.exports = __webpack_public_path__ + "img/prestige-coupon-active@3x.png";